module.exports = __webpack_public_path__ + "media/images/backgrounds/angle-top-right-outer-f30cdc7a6c2304572593c8b749ac8db4.svg";